export default {
  viewBox: "0 0 16 16",
  html: "<path fill-rule=\"evenodd\" d=\"M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0m9.35-.656a.75.75 0 0 1 0 1.312L7.114 10.73A.75.75 0 0 1 6 10.075v-4.15a.75.75 0 0 1 1.114-.656z\" clip-rule=\"evenodd\"/>"
};